import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LessonRow } from "@/pages/enseignement/AgendaTeachingPage";

const todayStr = () => new Date().toISOString().slice(0, 10);

// « Mes cours » — vue élève : uniquement ses cours individuels et ceux de ses classes (lecture seule)
export default function MesCoursPage() {
  const { lang, t } = useAuth();
  const [lessons, setLessons] = useState([]);

  useEffect(() => {
    api.get("/teaching/lessons").then((r) => setLessons(r.data.lessons)).catch(() => {});
  }, []);

  const today = todayStr();
  const upcoming = lessons.filter((l) => l.date >= today);
  const past = lessons.filter((l) => l.date < today).reverse();

  return (
    <div className="space-y-4 max-w-3xl" data-testid="student-lessons-page">
      <h2 className="font-heading text-2xl font-bold flex items-center gap-2">
        <CalendarDays className="h-6 w-6 brand" /> {t("teach.nav_lessons")}
      </h2>

      <div className="space-y-2">
        <p className="text-xs uppercase tracking-wider t-secondary">{t("teach.upcoming_lessons")}</p>
        {upcoming.length === 0 ? (
          <p className="text-sm t-secondary py-4 text-center" data-testid="student-lessons-empty">{t("teach.no_lessons")}</p>
        ) : (
          upcoming.map((l) => <LessonRow key={l.id} l={l} lang={lang} t={t} canEdit={false} />)
        )}
      </div>

      {past.length > 0 && (
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-wider t-secondary">{t("teach.past_lessons")}</p>
          {past.map((l) => <LessonRow key={l.id} l={l} lang={lang} t={t} canEdit={false} />)}
        </div>
      )}
    </div>
  );
}
